export default __webpack_public_path__ + "static/media/darkback.81c108db.jpg";